<template>
    <div class="capital_flow_outside hexiaoStaff">
      <p>联盟商家</p>
      <div class="capital_flow_container">
        <!-- 条件筛选 -->
        <el-form ref="conditionForm" :model="conditionForm" label-width="70px" :inline="true" class="demo-form-inline">
          <el-form-item label="用户信息">
	            <el-input v-model="conditionForm.msg" placeholder="员工信息" class="w160" size="small"></el-input>
	          </el-form-item>
          <el-form-item label="员工状态">
            <el-select v-model="conditionForm.status" placeholder="请选择变动类型">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="开启" :value="1"></el-option>
              <el-option label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变动时间">
            <el-date-picker
              v-model="timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="changeTime"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchData">开始检索</el-button>
            <el-button @click="onReset">重置检索</el-button>
          </el-form-item>
        </el-form>
        <div class="mb20">
          <el-button type="primary" @click="addMerchant" size="small" icon="el-icon-plus"  v-if="!yiyebtnDisabled" >添加联盟商家</el-button>
        </div> 
        <el-table
          :data="staffData"
          style="width: 100%">
          <el-table-column
            prop="wx_nickname"
            label="微信昵称"
            >
          </el-table-column>
          <el-table-column
            prop="head_image"
            label="头像"
            >
            <template slot-scope="scope">
	            <img :src="scope.row.head_image" alt width="60px" height="60px" v-if="scope.row.head_image"/>
	            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
	          </template>
          </el-table-column>
          <el-table-column label="名称" prop="name"></el-table-column>
          
          <el-table-column label="关联活动">
            <template slot-scope="scope">
              <el-tooltip placement="right">
                <div slot="content">
                  <p v-for="(item, index) in scope.row.activityName" :key="index">{{item}}</p>
                </div>
                <el-button type="text">{{scope.row.activity_num_text}}</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="总单数" prop="singular"></el-table-column>
          <el-table-column label="二选一商家" prop="is_single_text"></el-table-column>
          <el-table-column label="员工类型" prop="user_type_text"></el-table-column>
          <el-table-column
            prop="create_time_text"
            label="绑定时间"
            >
          </el-table-column>
      
          <el-table-column fixed="right" label="操作" width="400">
						<template slot-scope="scope">
							<el-button type="primary" size="small" @click="addStaff(scope.row.id)">添加员工</el-button>
							<el-button type="primary" size="small" @click="getStaffInfo(scope.row.id,1)">查看员工数据</el-button>
              <el-button type="primary" size="small" icon="el-icon-delete" @click="deleteStaff(scope.row.id)">删除</el-button>
							<el-button type="primary" size="small" v-if="!scope.row.register_time" @click="showDiffQr(scope.row.id)">查看二维码</el-button>
						</template>
        	</el-table-column> 
        </el-table>
        <el-pagination
          background
          layout="total,prev, pager, next"
          :current-page ='pages.current_page'
          :page-size='pages.page_size' 
          :pager-count='pages.page_count' 
          :page-count="pages.total_pages"
          :total="pages.total"
          @current-change= "currentChange">
        </el-pagination>
      </div>
      <!-- 二维码弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <el-image
          style="width: 200px; height: 200px"
          :src="qrResult.qr_img"
          ></el-image>
      <p>{{qrResult.text}}</p>
    </el-dialog>
    <!-- 员工海报弹框 -->
    <el-dialog
      title="添加员工"
      :visible.sync="addStaffdialogVisible"
      width="30%">
      <el-image
          style="width: 80%;border-radius: 8px;"
          :src="addStaffResult.img"
          lazy
          ></el-image>

      <p>请将该海报下载后分享给您的员工微信，进行绑定</p>
      <el-button type="primary" style="width: 70%; margin-top:20px" @click="onDownload">下载</el-button>
    </el-dialog>
    <!-- 查看员工详情 -->
    <el-dialog :title="`查看员工数据（${diff_company_name}）`" :visible.sync="dialogTableVisible">
       <!-- 条件筛选 -->
        <el-form ref="conditionForm2" :model="conditionForm2" label-width="120px" :inline="true" class="demo-form-inline" style="text-align: left;">
          <el-form-item label="">
	            <el-input v-model="conditionForm2.keywords" placeholder="请输入员工昵称" class="w160" size="small"></el-input>
	          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="searchData2" size="small">搜索</el-button>
           
          </el-form-item>
        </el-form>
      <el-table :data="gridData">
        <el-table-column property="name" label="员工姓名" ></el-table-column>
        <el-table-column  label="微信头像昵称"  align="center">
          <template slot-scope="scope">
						<img :src="scope.row.headimgurl" alt width="60px" height="60px" v-if="scope.row.headimgurl" style="margin:auto"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else style="margin:auto"/>
						<p>{{scope.row.nickname}}</p>
					</template>
        </el-table-column>
        <el-table-column property="orderNum" label="成交单数"></el-table-column>
        <el-table-column property="sum" label="成交总额"></el-table-column>
        <el-table-column property="godNum" label="客户总数"></el-table-column>
        <!-- <el-table-column property="godDes1" label="客户总数描述1"></el-table-column>
        <el-table-column property="godDes2" label="客户总数描述2"></el-table-column> -->
        <el-table-column property="commission" label="累计佣金"></el-table-column>
        <el-table-column property="bg" label="暴光总数"></el-table-column>
        <el-table-column property="zf" label="转发总数"></el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :current-page ='pages1.current_page'
          :page-size='pages1.page_size' 
          :pager-count='pages1.page_count' 
          :page-count="pages1.total_pages"
          :total="pages1.total"
          @current-change= "currentChange2">
        </el-pagination>
    </el-dialog>
    </div>
</template>
<script>
import api from "@/api.js";
import {pagination} from "@/util/util.js";
export default {
  name:'tkMerchant',
  data() {
    return {
      dialogVisible: false,//二维码对话框
      addStaffdialogVisible: false,//添加员工对话框
      dialogTableVisible:false,//查看员工对话框
      codeUrl:'',
      centerDialogVisible: false,
      btnDisabled:false,
      yiyebtnDisabled:false,
      timeData:'',
      conditionForm:{
        msg:'',
        start_time:'',
        end_time:'',
        status:0,
        page:1
      },
      conditionForm2:{
        keywords:'',
        page:1
      },
      active:{},
      staffData: [{
        id:'',
        wx_nickname: '',
        head_image: '',
        register_time:'',
        status:1,
        openid:'',
        create_time_text:'',
        status_text:'',
        
      }],
      pages:{
        page_size:1,//每页数量
        current_page: 1,//当前页
        page_count: 11,//页码按钮的数量，当总页数超过该值时会折叠，只能设5-21的奇数
        total_pages: 1,//总页数
        total:0
      },
      status:0,
      qrResult:{},//二维码结果信息
      addStaffResult:{},//添加员工海报图片
      gridData:[],//员工列表数据
      pages1:{
        page_size:5,//每页数量
        current_page: 1,//当前页
        page_count: 11,//页码按钮的数量，当总页数超过该值时会折叠，只能设5-21的奇数
        total_pages: 1,//总页数
        total:0
      },
      diff_company_name: ''
    }
  },
  mounted() {
   
    this.getstaffData();
  },
  methods: {
    //获取核销员工信息
    getstaffData(){
      this.axios.post(api.diffUserList ,this.conditionForm)
      .then(res =>{
        if(res.data.code == 0){
          if(res.data.result.open_yiye == 0){
            this.yiyebtnDisabled = true
          }
          this.staffData = res.data.result.list//员工列表
          this.pages.page_size = res.data.page.page_size//每页显示条数
          this.pages.total_pages = res.data.page.total_pages//总页数
          this.pages.current_page = res.data.page.current_page//当前页
          this.pages.total = res.data.page.total_rows//总条数
        }
      })
    },
    //选择筛选时间
    changeTime(timeValue){
      if(timeValue){
        this.conditionForm.start_time = timeValue[0]
        this.conditionForm.end_time = timeValue[1]
      }else{
        this.conditionForm.start_time = ''
        this.conditionForm.end_time = ''
      }
    },
    //检索
    searchData(){
      this.conditionForm.page = 1;
      this.getstaffData();
    },
     // 重置检索
    onReset() {
      this.conditionForm.start_time = '';
      this.conditionForm.end_time = '';
      this.timeData=''
      this.conditionForm.msg=''
      this.conditionForm.status=0
      // this.conditionForm.type = 0;
      this.conditionForm.page = 1;
      this.getstaffData();
    },
    // 分页
    currentChange(page) {
      this.conditionForm.page = page;
      this.getstaffData();
    },
 
    // 删除核销员工
    deleteStaff(id){
      this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios
            .post(api.diffUserDel,{id:id})
            .then(res=>{
              if(res.data.code == 0){
                this.$message.success(res.data.msg);
                // this.btnDisabled = false
                this.getstaffData();
              }
            }).catch(res => {});
        }).catch(() => {
          // this.btnDisabled = false
          this.$message({
            type: 'info',
            message: '您已取消删除'
          });          
        });   
    },
    addMerchant() {
      this.$router.push({name: 'addOrEditMerchant'});
    },
    //显示二维码id
    showDiffQr(id){
      this.axios
        .post(api.showDiffQr ,{id:id})
        .then(res=>{
          if(res.data.code == 0){
            this.qrResult = res.data.result
            this.dialogVisible= true
          }
        }).catch(res => {});
    },
    addStaff(id){
      this.addStaffResult.id = id
      this.axios
        .post(api.addAlert,{id:id})
        .then(res=>{
          if(res.data.code == 0){
            this.$nextTick(function(){
              this.addStaffResult.img = res.data.img
              this.addStaffResult.base64 = res.data.base64
              this.addStaffdialogVisible= true
            })
          }
        }).catch(res => {});
    },
    onDownload() {
      let _this = this;
      // 解决跨域 Canvas 污染问题
      let image = document.createElement('img');
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "QrcodeImage"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = _this.addStaffResult.base64;     //替换图片的base64 
    },
    //getStaffInfo 查看员工数据
    getStaffInfo(id,flag){
      if(flag == 1){
        this.conditionForm2.keywords =""
        this.conditionForm2.page = 1
      }
      this.conditionForm2.id=id
      this.axios.post(api.workerStaff ,this.conditionForm2)
      .then(res =>{
        if(res.data.code == 0){
          this.dialogTableVisible= true
          this.gridData = res.data.list//员工列表
          this.diff_company_name = res.data.diff_company_name
          // this.pages1.page_size = res.data.page.page_size//每页显示条数
          this.pages1.total_pages = res.data.all_page//总页数
          this.pages1.current_page = res.data.page//当前页
          // this.pages1.total = res.data.page.total_rows//总条数
        }
      })
    },
    //检索
    searchData2(){
      this.conditionForm2.page = 1;
      this.getStaffInfo(this.conditionForm2.id,2)
    },
    // 分页
    currentChange2(page) {
      this.conditionForm2.page = page;
      this.getStaffInfo(this.conditionForm2.id,2);
    }
  }
}
</script>
